import React from 'react';
import { useSessionStats } from 'context';
import { useAccountStats } from 'context';
import './StatsPanel.css';

const StatsPanel = () => {
  const { sessionResults } = useSessionStats();
  const { stats } = useAccountStats();

  const sessionTotal = Object.keys(sessionResults).length;
  const sessionCorrect = Object.values(sessionResults).filter(v => v === 'correct').length;
  const hasSession = sessionTotal > 0;

  const accountRows = [
    {
      label: 'Words used',
      value: stats ? stats.wordCount     : 0,
      total: stats ? stats.wordLimit     : 1,
    },
    {
      label: 'Categories used',
      value: stats ? stats.categoryCount : 0,
      total: stats ? stats.categoryLimit : 1,
    },
  ];

  return (
    <div className="stats-panel">
      {hasSession && (
        <div className="stats-item stats-session-item">
          <div className="stats-row">
            <span className="stats-label">Correct this pass</span>
            <span className="stats-value">
              {sessionCorrect} <span className="stats-total">/ {sessionTotal}</span>
            </span>
          </div>
          <div className="stats-bar-track">
            <div
              className="stats-bar-fill"
              style={{ width: `${Math.round((sessionCorrect / sessionTotal) * 100)}%` }}
            />
          </div>
        </div>
      )}
      {accountRows.map(({ label, value, total }) => (
        <div key={label} className="stats-item">
          <div className="stats-row">
            <span className="stats-label">{label}</span>
            <span className="stats-value">
              {stats ? value : '…'}
              {' '}<span className="stats-total">/ {stats ? total : '…'}</span>
            </span>
          </div>
          <div className="stats-bar-track">
            <div
              className="stats-bar-fill"
              style={{ width: stats ? `${Math.round((value / total) * 100)}%` : '0%' }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export { StatsPanel };
